import { AvatarCard } from '@components/AvatarCard'
import Page from '@components/Page/Page'
import { SettingsCard } from '@components/SettingsCard'
import {
  CustomCategoryMenu,
  useSettingMenuItems,
} from '@hooks/useSettingMenuItems'
import { HELP_CENTER_URL } from '@utils/urls'
import { Card, Col, Flex, Input, Row, Typography } from 'antd'
import { useState } from 'react'
import { Link } from 'react-router-dom'

const { Title, Text } = Typography
const COLUMNS = 3

const SettingsPage = () => {
  const { menu } = useSettingMenuItems()
  const [filteredMenuItems, setFilteredMenuItems] =
    useState<CustomCategoryMenu[]>(menu)

  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const searchQuery = event.target.value.toLowerCase()

    const updatedMenuItems = menu
      .map((categorySection) => {
        const filteredItems = categorySection.items
          .map((menuItem) => {
            const filteredChildren = menuItem.children?.filter(
              (child) =>
                child.title.toLowerCase().includes(searchQuery) ||
                child.description.toLowerCase().includes(searchQuery)
            )
            return {
              ...menuItem,
              children: filteredChildren,
            }
          })
          .filter(
            (menuItem) => menuItem.children && menuItem.children.length > 0
          )

        return {
          ...categorySection,
          items: filteredItems,
        }
      })
      .filter((categorySection) => categorySection.items.length > 0)

    setFilteredMenuItems(updatedMenuItems)
  }

  return (
    <Page>
      <Card style={{ marginTop: 24, marginBottom: 24 }}>
        <Flex vertical align="center" gap={24} style={{ padding: 20 }}>
          <Title className="m-0" level={1}>
            Workspace settings
          </Title>
          <Input
            style={{ width: '100%', maxWidth: 500 }}
            placeholder="Search"
            allowClear
            size="large"
            onChange={handleSearchChange}
          />
          <Text>
            You need help ?{' '}
            <Link to={HELP_CENTER_URL} target="blank">
              Read the documentation
            </Link>{' '}
          </Text>
        </Flex>
      </Card>

      {filteredMenuItems.map((category) => {
        if (category.key === 'tools') {
          return (
            <Row key={category.key} style={{ marginBottom: 32 }}>
              <Title level={5}>{category.label}</Title>
              <Col span={24}>
                <Card>
                  {category.items.map((menuItem) => (
                    <Col key={menuItem.key} span={24}>
                      <Row gutter={[16, 16]}>
                        {menuItem.children?.map((child) => (
                          <Col
                            key={child.key}
                            span={24 / 4}
                            style={{ textAlign: 'center' }}
                          >
                            <AvatarCard
                              key={child.key}
                              item={child}
                              color={menuItem.color}
                            />
                          </Col>
                        ))}
                      </Row>
                    </Col>
                  ))}
                </Card>
              </Col>
            </Row>
          )
        }

        return (
          <Row key={category.key} style={{ marginBottom: 32 }}>
            {category.items.map((menuItem) => (
              <Col key={menuItem.key} span={24}>
                <Title level={5}>{menuItem.label}</Title>
                <Row gutter={[16, 16]}>
                  {menuItem.children?.map((child) => (
                    <Col key={child.key} span={24 / COLUMNS}>
                      <SettingsCard
                        key={child.key}
                        item={child}
                        color={menuItem.color}
                      />
                    </Col>
                  ))}
                </Row>
              </Col>
            ))}
          </Row>
        )
      })}
    </Page>
  )
}

export default SettingsPage
